// Hulpfuncties voor het scherm AI-radar (geen React, zodat ze los te testen zijn).

export const SOORTEN = {
  citatie: { label: "Geciteerd", uitleg: "Met webzoeken: wordt het merk genoemd of de eigen site als bron gebruikt?" },
  onthouden: { label: "Onthouden", uitleg: "Zonder webzoeken: weet het model zelf wat het merk is, en klopt dat?" },
  agent: { label: "Gekozen door agents", uitleg: "Een AI-agent zoekt aanbieders en maakt een shortlist: staat het merk erbij?" },
};

export const AANBIEDERS = { anthropic: "Claude", openai: "ChatGPT", gemini: "Gemini", perplexity: "Perplexity" };

export const pct = (x) => (x == null || Number.isNaN(Number(x)) ? "-" : Math.round(Number(x) * 100) + "%");

// "40% (tussen 22% en 61%, 10 metingen)": een kans met marge, nooit een kaal ja of nee.
export function kansTekst(r) {
  if (!r || !r.n) return "Nog geen metingen";
  return `${pct(r.kans)} (tussen ${pct(r.laag)} en ${pct(r.hoog)}, ${r.n} metingen)`;
}

// Kleur op basis van de ondergrens: pas groen als zelfs de voorzichtige schatting hoog is.
export function kansKleur(r, C) {
  if (!r || !r.n || r.n < 4) return C.muted;
  if (r.laag >= 0.5) return C.green;
  if (r.hoog < 0.25) return C.red;
  return C.yellow;
}

// Verschil tussen de laatste en de vorige ronde voor één soort, alleen als er genoeg metingen zijn.
export function verschil(trend, soort) {
  const reeks = (trend || []).filter((t) => t.soort === soort && t.n >= 4).sort((a, b) => String(a.gestart_op).localeCompare(String(b.gestart_op)));
  if (reeks.length < 2) return null;
  return reeks[reeks.length - 1].kans - reeks[reeks.length - 2].kans;
}

export const verschilTekst = (v) => (v == null ? "geen vergelijking" : (v > 0 ? "+" : "") + Math.round(v * 100) + " procentpunt t.o.v. vorige ronde");
